import { SOCIAL_MEDIA_LINKS } from 'utils/socialMediaConstants';

export const getSchemaIds = siteUrl => {
  const baseUrl = String(siteUrl || '').replace(/\/$/, '');
  const homeUrl = `${baseUrl}/`;
  return {
    baseUrl,
    homeUrl,
    orgId: `${baseUrl}/#organization`,
    siteId: `${baseUrl}/#website`,
    logoId: `${baseUrl}/#logo`,
  };
};

export const buildOrganizationNode = ({
  siteUrl,
  siteName,
  description,
  logoUrl,
  alternateName,
  parentOrganization,
  contactPoint,
  address,
}) => {
  const { homeUrl, orgId, logoId } = getSchemaIds(siteUrl);
  const sameAs = [
    SOCIAL_MEDIA_LINKS.instagram,
    SOCIAL_MEDIA_LINKS.facebook,
    SOCIAL_MEDIA_LINKS.twitter,
    SOCIAL_MEDIA_LINKS.youtube,
  ].filter(Boolean);

  const node = {
    '@type': 'Organization',
    '@id': orgId,
    name: siteName,
    url: homeUrl,
    description,
    logo: {
      '@type': 'ImageObject',
      '@id': logoId,
      url: logoUrl,
      contentUrl: logoUrl,
      caption: siteName,
    },
    image: { '@id': logoId },
    sameAs,
  };

  if (alternateName) node.alternateName = alternateName;

  if (parentOrganization) {
    node.parentOrganization = {
      '@type': 'Organization',
      name: parentOrganization.name,
      url: parentOrganization.url,
    };
  }

  if (contactPoint) {
    node.contactPoint = {
      '@type': 'ContactPoint',
      telephone: contactPoint.telephone,
      email: contactPoint.email,
      contactType: contactPoint.contactType || 'customer service',
    };
  }

  if (address) node.address = address;

  return node;
};

export const buildOrganizationGraph = args => ({
  '@context': 'https://schema.org',
  ...buildOrganizationNode(args),
});
